// this is an autogenerated file from App/Account/Content/Orders/Filters/AppChooser/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Orders_Filters_AppChooser{
  apps_external_mappings(
    where: { resource_table: { _eq: "orders" } }
    distinct_on: connection_id
  ) {
    id
    connection {
      app {
        id
        name
      }
    }
  }
}

`